// @ts-strict-ignore
import { Grid } from '@mytours/components'
import React, { useMemo } from 'react'
import { CollectionItem } from 'mytours-read-common'

import MenuListItem from './MenuListItem'
import { ionHistory } from '../../../navigation'

import './styles/menuList.less'

interface Props {
	activePageId: number
	list: CollectionItem[]
	navigateToItem: (id: number) => void
}

const MenuList: React.FC<Props> = props => {
	const isActive = (id: number): boolean => {
		const activeId = (ionHistory.location?.state as any)?.activeMenuId || props.activePageId
		return id === activeId
	}

	const renderRow = useMemo<JSX.Element[] | null>(() => {
		const { list } = props

		if (!list) {
			return null
		}

		return list.map((item: CollectionItem, index: number) => (
			<MenuListItem
				item={item}
				isActive={isActive(item.id)}
				onSelect={() => props.navigateToItem(item.id)}
				key={index}
			/>
		))
	}, [props.list])

	return <Grid className="menu-list-wrapper">{renderRow}</Grid>
}

export default MenuList
